import {
  Typography,
  type TypographyProps,
} from '@jouzen/ecom-components/v3/Typography';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

import getValues from '../utils/getValues';

interface ParagraphProps extends Omit<TypographyProps, 'children'> {
  readonly tx: MessageKey;
}

const values = getValues();

const P = ({ tx, ...props }: ParagraphProps) => {
  return (
    <Typography {...props}>
      <RichText messageKey={tx} tValues={values} />
    </Typography>
  );
};

export default P;
